module.exports = __webpack_public_path__ + "static/insta-c093aea533319f4c8ec55e100e8efa71.jpg";